import { createSlice } from '@reduxjs/toolkit'
import { initActivityWidget, applyParsedWidgetResponse } from 'utils/screens/manage-card'

const initialState = {
  // Flow input params
  flowInputParams: {
    productName: null,
  },

  // Card details fetched from cards search
  card: null,

  // Card widget details from PS
  cardWidget: null,

  // Activity card widget
  activityWidget: null,

  // Funding options fetched from ccls funding-options.GET
  fundingOptions: null,

  toastMessage: null,

  // hide/show risk denied sheet component
  riskDenied: null,

  // Card's notification preferences
  notificationPreference: null,

  // This flag indicates if the user has returned to the card summary
  // after completing the step up flow triggered by the unlock card action
  isUnlockPostStepUp: null,
}

const manageCardSlice = createSlice({
  name: 'manageCard',
  initialState,
  reducers: {
    initFlowInputParams(state, action) {
      const { productName } = action.payload || {}
      state.flowInputParams.productName = productName
    },
    initManageCard(state, action) {
      const {
        card,
        activityWidget,
        widgets,
        engagementCards,
        billingAddresses,
        fundingOptions,
        channelPreference,
        isUnlockPostStepUp,
      } = action.payload
      state.card = card
      initActivityWidget(activityWidget)
      state.activityWidget = activityWidget
      ;(state as any).engagementCards = engagementCards
      ;(state as any).billingAddresses = billingAddresses
      state.fundingOptions = fundingOptions
      state.notificationPreference = channelPreference
      state.isUnlockPostStepUp = isUnlockPostStepUp
      applyParsedWidgetResponse(state, widgets)
    },
    setFundingOptions(state, action) {
      state.fundingOptions = action.payload
    },
    setRiskDenied(state, action) {
      state.riskDenied = action.payload
    },
    clearRiskDenied(state) {
      state.riskDenied = null
    },
    setToastMessage(state, action) {
      state.toastMessage = action.payload?.toastMessage
    },
    clearToastMessage(state) {
      state.toastMessage = null
    },
    updateCard(state, action) {
      const { card, widgets } = action.payload
      if (state.card) {
        const { cardHolder, cardLimits, additionalDetails } = state.card
        state.card = { ...card, cardHolder, cardLimits, additionalDetails } || {}
      } else {
        state.card = card || {}
      }
      applyParsedWidgetResponse(state, widgets)
    },
    resetActionWidget(state) {
      ;(state as any).actionWidget = null
    },
    clearStepUpStatus(state) {
      state.isUnlockPostStepUp = null
    },
  },
})

// Custom selectors
export const selectCard = (state) => state.manageCard.card
export const selectCardWidget = (state) => state.manageCard.cardWidget
export const selectActivityWidget = (state) => state.manageCard.activityWidget
export const selectBillingAddress = (state) => state.manageCard.billingAddresses
export const selectActionWidget = (state) => state.manageCard.actionWidget
export const selectNotificationWidgets = (state) => state.manageCard.notificationWidgets
export const selectEngagementCards = (state) => state.manageCard.engagementCards
export const selectFundingOptions = (state) => state.manageCard.fundingOptions
export const selectToastMessage = (state) => state.manageCard?.toastMessage
export const selectRiskDenied = (state) => state.manageCard.riskDenied
export const selectNotificationPreference = (state) => state.manageCard.notificationPreference
export const selectIsUnlockPostStepUp = (state) => state.manageCard.isUnlockPostStepUp

export const {
  initManageCard,
  setFundingOptions,
  initFlowInputParams,
  setToastMessage,
  clearToastMessage,
  updateCard,
  setRiskDenied,
  clearRiskDenied,
  resetActionWidget,
  clearStepUpStatus,
} = manageCardSlice.actions

export default manageCardSlice.reducer
